import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export const Title = styled.h1``;

export const CDIC = styled.div`
  margin: 3rem 0;
`;

export const Img = styled.img`
  width: 300px;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    width: 400px;
  }
`;
